import Wallet from './views/Wallet.vue';
import WalletModule from './views/Module.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import WalletWithdraw from './views/WalletWithdraw.vue';
import MakeDeposit from './views/MakeDeposit.vue';
import DepositProof from './views/DepositProof.vue';
import DepositPaymentMethod from './views/DepositPaymentMethod.vue';
import WithdrawSelectAccount from './views/WithdrawSelectAccount.vue';
import WithdrawSelectedAccountDetail from './views/WithdrawSelectedAccountDetail.vue';
import DepositWithdrawReport from './views/DepositWithdrawReport.vue';


const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
        {
            path: 'wallet',
            name: 'wallet',
            component: Wallet,
            meta: {
                title: 'Wallet'
            }
        },
        {
            path: 'deposit-withdraw-report',
            name: 'deposit-withdraw-report',
            component: DepositWithdrawReport,
            meta: {
                title: 'Deposit & Withdraw Report'
            }
        },
        {
            path: 'wallet-withdraw',
            name: 'wallet-withdraw',
            component: WalletWithdraw,
            meta: {
                title: 'Withdraw'
            }
        },
        {
            path: 'withdraw-select-account',
            name: 'withdraw-select-account',
            component: WithdrawSelectAccount,
            meta: {
                title: 'Back To Amount'
            }
        },
        {
            path: 'withdraw-selected-account-detail',
            name: 'withdraw-selected-account-detail',
            component: WithdrawSelectedAccountDetail,
            meta: {
                title: 'Back To Select Account'
            }
        },
        {
            path: 'wallet-deposit',
            name: 'wallet-deposit',
            component: WalletDeposit,
            meta: {
                title: 'Deposit'
            }
        },
        {
            path: 'deposit-payment-method',
            name: 'deposit-payment-method',
            component: DepositPaymentMethod,
            meta: {
                title: 'Deposit'
            }
        },
        {
            path: 'make-deposit',
            name: 'make-deposit',
            component: MakeDeposit,
            meta: {
                title: 'Deposit'
            }
        },
        {
            path: 'proof',
            name: 'proof',
            component: DepositProof,
            meta: {
                title: 'Deposit'
            }
        },
    ],
}

export default WalletRoutes;